export default {
  // somehow the flag "us939-deal-lite-navigation" maps to the "us939DealLiteNavigation" in the LD react client
  US939_DEAL_LITE_NAVIGATION: "us939DealLiteNavigation",
  US1632_DOMO_REPORTING_PAGE: "us1632DomoReportingPage",
  US1876_DEPRECATE_SISENSE_REPORTS: "us1876DeprecateSisenseReports",
  US1304_BROKER_FRONTEND_URL: "us1304BrokerFrontendUrlEnvironmentVariable",
  US1999_BROKER_FRONTEND_REDIRECT: "us1999RedirectToBrokerApp",
  ZEP34_HIDE_LOAN_GI_AMORT_DETAIL_EDIT: "zep34HideLoanGiAndAmortEditDetailsButtons",
  GLA453_CLIENTS_WHO_USE_NEW_METRICS: "gla453ClientsWhoUseNewMetrics",
  GLA453_SYSTEM_ADMINISTRATORS_USE_NEW_METRICS: "gla453SystemAdministratorsUseNewMetrics",
  GLA453_USE_NEW_METRICS: "gla453UseNewMetrics",
  BAR1837_SHOW_ONBOARDING_NAV_LINK: "bar1837ShowOnboardingNavLinkByTenant",
  MASTER_CASHFLOWS_FEATURE: "bar1272ShowMasterCashflowsButton",
  BAR2599_REPORTING_SECTION_ON_LOAN_DETAILS_PAGE: "bar2599ReportingSectionOnLoanDetailsPage",
  BAR2105_REDIRECT_TO_NEW_HEDGE_VIEW_PAGE: "bar2105RedirectToNewHedgeViewPage",
  BAR2104_REDIRECT_TO_NEW_PROPERTY_VIEW_PAGE: "bar2104RedirectToPropertyViewPage"
};
